
    import "/home/git/waysglob/website/src/components/project-item/index.module.scss.FARM_CSS_MODULES?87b871b3";
    
    export default {"title": `title-996ccf4d`,"img": `img-996ccf4d`,"description": `description-996ccf4d`,"left-wrapper": `left-wrapper-996ccf4d`,"right-wrapper": `right-wrapper-996ccf4d`,"row": `row-996ccf4d`}
    